import React from 'react'
import { Page, Card, DataTable, Loading, Heading, Layout, TextStyle } from '@shopify/polaris'
import Api from '../../lib/api';


class Reports extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            stats: [],
            orderStats: {
                stats: []
            }
        }
    }
    componentDidMount() {
        Api.getReports().then(({ data }) => {
            this.setState({
                loading: false,
                stats: data.filter(function (stat) {
                    if (stat.referrer != null) {
                        return true;
                    }
                })
            })
        })
        Api.getOrderReports().then(({ data }) => {
            this.setState({
                loading: false,
                orderStats: data
            })
        })

    }
    render() {
        const stats = this.state.stats
        const orderStats = this.state.orderStats

        const rows = stats.map(function (stat, index) {
            return [index + 1, `${stat.referrer}`, stat.count]
        })
        console.log(orderStats)
        const orderRows = orderStats.stats.map(function (stat, index) {

            return [index + 1, `${stat.referrer}`, stat.count, `${stat.percentage.toFixed(2)}%`]
        })


        return (

            <Page
                title="Reports"
                breadcrumbs={[{ content: 'Customers', url: '/customers' }]}
                primaryAction={{
                    content: "Generate CSV Report",
                    external: true,
                    url: '/reports/generate'
                }}
            >

                {this.state.loading && <Loading />}

                {!this.state.loading &&
                    <Layout>
                        <Layout.Section oneHalf>
                        <Card title="All Orders">
                                <Card.Section>
                                    <DataTable
                                        columnContentTypes={[
                                            'numeric',
                                            'text',
                                            'numeric',
                                            'text',
                                        ]}
                                        headings={[
                                            '#',
                                            'Referrer',
                                            'Orders Count',
                                            'Percentage'
                                        ]}
                                        rows={orderRows}
                                    />
                                </Card.Section>
                            </Card>
                        </Layout.Section>
                        <Layout.Section oneHalf>
                            <Card title="All Customers">
                                <Card.Section>
                                    <DataTable
                                        columnContentTypes={[
                                            'numeric',
                                            'text',
                                            'numeric'
                                        ]}
                                        headings={[
                                            '#',
                                            'Referrer',
                                            'Customers Count'
                                        ]}
                                        rows={rows}
                                    />
                                </Card.Section>
                            </Card>
                        </Layout.Section>
                    </Layout>}

            </Page>
        );
    }
}

export default Reports
